/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';
import type HandoffToZendeskAgentStepType from 'embercom/models/operator/visual-builder/step/handoff-to-zendesk-agent';

interface Args {
  isReadOnly: boolean;
  step: HandoffToZendeskAgentStepType;
}

const Settings = templateOnlyComponent<Args>();
export default Settings;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HandoffToZendeskAgent::Settings': typeof Settings;
    'workflows/graph-editor/node-items/steps/handoff-to-zendesk-agent/settings': typeof Settings;
  }
}
